import { Menu, ActionIcon } from '@mantine/core';
import { ExternalLink } from 'react-feather';

type LatLongMenuProps = {
  coordinates: number[];
  size?: number; // optional
};

export const LatLongMenu = ({ coordinates, size }: LatLongMenuProps) => {
  const [lng, lat] = coordinates;
  return (
    <Menu shadow="md" position="bottom-start">
      <Menu.Target>
        <ActionIcon aria-label="External link">
          <ExternalLink size={size} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          component="a"
          href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`}
          target="_blank"
          rel="noreferrer"
        >
          Open in Google Maps
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
